export const REQUESTS_SLICE_NAME = "requests"
